import { from } from "rxjs";
import {Client} from './client';
import {Project} from './project'

export class AssignmentQueueRequest {

    id: number;
    memberId: string;
    clientList:[Client];
    projectList:[Project];
    coderId: number;
    userId: number;
    coderName: string;
    coderLevel: string;
    qaNeeded: string;
    assignedClients: number[];
    assignedProjects: number[];
    clientNames: string;
    projectNames: string;
    updatedBy: string;
}